<app-crud-create
#createTitulo
[fields]="fields"
[title]="'título'"
[description]="'En esta sección podrás ingresar el detalle del Título'"
[apiService]="tituloService"
(selectFieldValueEmit)="reloadCaracterByNivel($event)"
></app-crud-create>
